(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      // We need to reload yotpo in order to see the stars
      yotpoWidgetsContainer.initWidgets();
    }, 1500);
  });
  document.addEventListener('DOMContentLoaded', function () {
    function hideZeroStars() {
      const interval = setInterval(function () {
        var elements = document.querySelectorAll('[id^="yotpoWidget"][data-yotpo-element-loaded="true"] > div');
        if (elements.length) {
          elements.forEach((element) => {
            if (element.querySelectorAll('.yotpo-sr-star-full').length) {
              element.parentElement.style.opacity = '1';
              clearInterval(interval);
            }
          });
        }
      }, 10);
      setTimeout(() => {
        clearInterval(interval);
      }, 2500);
    }
    setTimeout(() => hideZeroStars(), 2000);
  });

  } catch(e) { console.error(e); }
})();
})();
